module.exports = __webpack_public_path__ + "static/media/checkmark_icon_green.8de3fe16.svg";